import { useFintechUiStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFintechUiComponents } from "@b2bportal/core-types";

import type { FintechMarketplaceConfig } from "../../FintechMarketplaceConfig";
import { FintechMarketplaceProductBreadcrumbItem } from "../FintechMarketplaceProductBreadcrumbItem";

import defaultStyles from "./FintechMarketplaceProductBreadcrumbList.module.scss";

export interface FintechMarketplaceProductBreadcrumbListProps
  extends Required<Pick<FintechMarketplaceConfig, "productsBreadcrumbs">> {
  currentProductKey: string;
}

export const FintechMarketplaceProductBreadcrumbList = (
  props: FintechMarketplaceProductBreadcrumbListProps
) => {
  const { currentProductKey, productsBreadcrumbs } = props;

  const [block, cn] = useModuleBEM(
    useFintechUiStyles(
      CoreFintechUiComponents.FintechMarketplaceProductBreadcrumbList,
      defaultStyles
    ),
    CoreFintechUiComponents.FintechMarketplaceProductBreadcrumbList
  );

  return (
    <div className={block}>
      {Object.entries(productsBreadcrumbs).map(
        ([key, breadcrumb]) =>
          breadcrumb != null && (
            <div
              key={key}
              className={cn("item", [], {
                current: key === currentProductKey,
              })}
            >
              <FintechMarketplaceProductBreadcrumbItem
                active={key === currentProductKey}
              >
                {breadcrumb}
              </FintechMarketplaceProductBreadcrumbItem>
            </div>
          )
      )}
    </div>
  );
};
